module.exports = __webpack_public_path__ + "img/food3.2bae1ff4.jpg";